import { render, staticRenderFns } from "./CashierRecordFooter.vue?vue&type=template&id=0e614ccb&scoped=true"
var script = {}
import style0 from "./CashierRecordFooter.vue?vue&type=style&index=0&id=0e614ccb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e614ccb",
  null
  
)

export default component.exports